import { render, staticRenderFns } from "./AccidentStatistics.vue?vue&type=template&id=1fb79fd8&scoped=true&"
import script from "./AccidentStatistics.vue?vue&type=script&lang=js&"
export * from "./AccidentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AccidentStatistics.vue?vue&type=style&index=0&id=1fb79fd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb79fd8",
  null
  
)

export default component.exports